import React from 'react';
import { config } from '../config';

export const Footer = () => {
  return (
    <footer className="bg-secondary text-white py-20">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-8">
              <img 
                src={config.logo}
                alt={config.church_name}
                loading="lazy"
                decoding="async"
                className="w-12 h-12 rounded-full object-cover border border-white/10"
              />
              <div>
                <h3 className="font-heading text-xl font-bold">{config.church_name}</h3>
                <p className="text-primary text-[10px] tracking-[0.2em] uppercase font-bold">{config.tagline}</p>
              </div>
            </div>
            <p className="text-white/40 text-sm max-w-sm leading-relaxed">
              A Christ-centered community dedicated to teaching the Word of God and demonstrating the love of Christ through practical living.
            </p>
          </div>
          
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.3em] text-primary mb-8">Quick Links</h4>
            <div className="flex flex-col gap-4">
              <a href="#about" className="text-white/60 hover:text-primary transition-colors text-sm">About Us</a>
              <a href="#services" className="text-white/60 hover:text-primary transition-colors text-sm">Services</a>
              <a href="#ministries" className="text-white/60 hover:text-primary transition-colors text-sm">Ministries</a>
              <a href="#contact" className="text-white/60 hover:text-primary transition-colors text-sm">Contact</a>
            </div>
          </div>
          
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.3em] text-primary mb-8">Service Times</h4>
            <div className="space-y-4 text-white/60 text-sm">
              <div>
                <p className="text-white font-medium mb-1">Sunday Worship</p>
                <p>{config.sunday_time}</p>
              </div>
              <div>
                <p className="text-white font-medium mb-1">Midweek Service</p>
                <p>{config.wednesday_time}</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-8">
          <div className="flex gap-6">
            <a href={config.socials.facebook} target="_blank" rel="noopener noreferrer" className="text-white/20 hover:text-primary transition-colors">Facebook</a>
            <a href={config.socials.tiktok} target="_blank" rel="noopener noreferrer" className="text-white/20 hover:text-primary transition-colors">TikTok</a>
            <a href={config.socials.youtube} target="_blank" rel="noopener noreferrer" className="text-white/20 hover:text-primary transition-colors">YouTube</a>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-white/20 text-[10px] uppercase tracking-widest">
              © 2024 {config.church_name}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
